// <s-matching-products> keeps the "Vous aimerez aussi" cards in the colour the shopper picks on the product above.
// Each card carries a colour → {url, image} map; cards without that colour keep their default look.
class MatchingProducts extends HTMLElement {
  #root = null;
  #onChange = (event) => {
    const field = event.target;
    if (!field || !this.dataset.colorOption || field.name !== this.dataset.colorOption) return;
    this.#apply(field.value);
  };

  connectedCallback() {
    if (!this.dataset.colorOption) return;
    this.#root = document.querySelector("[data-product-root]") ?? document;
    this.#root.addEventListener("change", this.#onChange);
  }

  disconnectedCallback() {
    this.#root?.removeEventListener("change", this.#onChange);
  }

  #apply(color) {
    const key = String(color || "").toLowerCase();
    for (const card of this.querySelectorAll("[data-match-card]")) {
      let colors = {};
      try {
        colors = JSON.parse(card.dataset.colors || "{}");
      } catch {
        colors = {};
      }
      const match = colors[key];
      const label = card.querySelector("[data-match-color]");
      if (!match) {
        if (label) label.hidden = true;
        continue;
      }
      const link = card.querySelector("[data-match-link]");
      const img = card.querySelector("[data-match-img]");
      if (link) link.href = match.u;
      if (img) {
        img.srcset = match.ss;
        img.src = match.s;
      }
      if (label) {
        label.textContent = match.n;
        label.hidden = false;
      }
    }
  }
}

if (!customElements.get("s-matching-products")) customElements.define("s-matching-products", MatchingProducts);
